module.exports = __webpack_public_path__ + "static/img/icon-shop-manage-recive.8bde2276.png";